import React from 'react';
import { Box, ButtonBase, InputBase } from '@mui/material';

/** Three-column − / value / + stepper (Stock In style), full width of container */
const StockQtyStepper = ({
  value,
  onChange,
  disabled,
  isDark,
  borderColor,
  ariaLabel = 'Quantity',
  ariaLabelIncrease = 'Increase value',
  ariaLabelDecrease = 'Decrease value',
  sx,
}) => {
  const parsed = parseFloat(String(value ?? '').replace(',', '.'));
  const safe = Number.isFinite(parsed) ? parsed : 0;

  const formatNum = (n) => {
    if (!Number.isFinite(n)) return '';
    if (Number.isInteger(n)) return String(n);
    const t = n.toFixed(4).replace(/\.?0+$/, '');
    return t;
  };

  const applyDelta = (delta) => {
    const next = Math.max(0, safe + delta);
    onChange(formatNum(next));
  };

  const handleInput = (e) => {
    const v = e.target.value;
    if (v === '' || /^-?\d*\.?\d*$/.test(v)) {
      onChange(v);
    }
  };

  const bg = isDark ? 'rgba(255,255,255,0.06)' : '#f8fafc';
  const fg = isDark ? '#f8fafc' : '#0f172a';
  const divider = borderColor;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        width: '100%',
        minWidth: 0,
        height: 40,
        borderRadius: 1.25,
        border: `1px solid ${borderColor}`,
        overflow: 'hidden',
        backgroundColor: bg,
        ...sx,
      }}
    >
      <ButtonBase
        type="button"
        disabled={disabled || safe <= 0}
        onClick={() => applyDelta(-1)}
        sx={{
          flex: 1,
          minWidth: 0,
          color: fg,
          fontSize: '1.4rem',
          fontWeight: 700,
          lineHeight: 1,
          transition: 'background-color 0.15s ease',
          '&:hover': { backgroundColor: isDark ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.05)' },
          '&.Mui-disabled': { opacity: 0.35 },
        }}
        aria-label={ariaLabelDecrease}
      >
        −
      </ButtonBase>
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderLeft: `1px solid ${divider}`,
          borderRight: `1px solid ${divider}`,
        }}
      >
        <InputBase
          value={value}
          onChange={handleInput}
          disabled={disabled}
          inputProps={{
            'aria-label': ariaLabel,
            inputMode: 'decimal',
            style: { textAlign: 'center', fontWeight: 700, fontSize: '0.95rem' },
          }}
          sx={{
            width: '100%',
            '& input': {
              py: 1,
              px: 0.5,
              color: fg,
              '&::placeholder': {
                color: isDark ? '#64748b' : '#94a3b8',
                opacity: 1,
              },
            },
          }}
          placeholder="0"
        />
      </Box>
      <ButtonBase
        type="button"
        disabled={disabled}
        onClick={() => applyDelta(1)}
        sx={{
          flex: 1,
          minWidth: 0,
          color: fg,
          fontSize: '1.4rem',
          fontWeight: 700,
          lineHeight: 1,
          transition: 'background-color 0.15s ease',
          '&:hover': { backgroundColor: isDark ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.05)' },
          '&.Mui-disabled': { opacity: 0.35 },
        }}
        aria-label={ariaLabelIncrease}
      >
        +
      </ButtonBase>
    </Box>
  );
};

export default StockQtyStepper;
